const afMessages = {
  /* 01.General */
  "chat.end": "Herbegin jou kletsgesprek",
  "chat.endall": "Beëindig klets",
  "chat.cancel": "Kanselleer",
  "chat.cookie":
    "Hierdie digitale assistent gebruik koekies om te verseker dat u die beste ervaring kry",
  "chat.learn": "Leer meer",
  "chat.minimize": "Minimaliseer",
  "chat.hide": "Naby",
  "chat.hidebot.text": "Close sal die avatar vir 15 minute laat verdwyn",
  "chat.hidebot": "Maak Bot toe",
  "chat.restart": "Begin oor",
  "switch.language": "Van taal wisselen",
  "switch.property": "Verander eiendom",
  "restart.converstation": "Herbegin omskakeling",
  "chat.endtext": "Is jy seker jy wil die huidige klets beëindig?",
  "check.availabity": "Gaan Beskikbaarheid na",
  "check.availabity.submit": "Indien",
  "check.availabity.cancel": "Kanselleer",
  "check.availabity.adults": "Volwassenes",
  "check.availabity.children": "Kinders",
  "check.availabity.child.age": "Ouderdom - kind",
  "feedback.leave": "Los terugvoer",
  "feedback.leave.message": "Los Boodskap",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Dien 'n Saak in",
  "caseform.system": "Stelsel",
  "caseform.loading.systems": "Laai stelsels...",
  "caseform.select.system": "Kies Stelsel",
  "caseform.error.systems": "Fout met laai van stelsels",
  "caseform.scenario": "Scenario",
  "caseform.loading.scenarios": "Laai scenario's...",
  "caseform.select.scenario": "Kies Scenario",
  "caseform.error.scenarios": "Fout met laai van scenario's",
  "caseform.topic": "Tema",
  "caseform.loading.topics": "Laai temas...",
  "caseform.select.topic": "Kies Tema",
  "caseform.error.topics": "Fout met laai van temas",
  "caseform.subject": "Onderwerp",
  "caseform.description": "Beskrywing",
  "caseform.submit": "Dien in",
  "caseform.cancel": "Kanselleer",
  "caseform.success.title": "Saak Geskep",
  "caseform.success.message": "Jou saak is suksesvol geskep.",
  "caseform.success.caseNumber": "Saaknommer:",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Kies 'n Aksie",
  "simpleaction.body":
    "Kies een van de volgende opties:{br}{b}Maak een zaak aan{/b} om een ondersteuningsverzoek in te dienen, of {b}Start een chat{/b} om nu verbinding te maken met een agent.",
  "simpleaction.startchat": "Start een chat",
  "simpleaction.createcase": "Maak een zaak aan",
  "caseform.error.generic": "Fout bij het aanmaken van de zaak.",
  "caseform.error.generic.message":
    "Er is een fout opgetreden bij het aanmaken van uw zaak. Probeer het later opnieuw.",
};
export default afMessages;
